import authenticatedFetch from '../utils/authenticatedFetch'
import { API_URL } from '../env'

export async function getSubscriptions(headers) {
  const response = await authenticatedFetch(`${API_URL}/restrictions/v1/recap/me`, { headers })
  const data = await response.json()
  return data
}
